<template>
  <div>
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="标题" style="width:500px;">
        <el-input v-model="form.title" clearable placeholder="请填写标题"></el-input>
      </el-form-item>
      <el-form-item label="用户id" style="width:500px;">
        <el-tooltip content="为空则为所有用户消息" placement="right">
          <el-input v-model="form.userID" clearable placeholder="用户id"></el-input>
        </el-tooltip>
      </el-form-item>
      <vue-ueditor-wrap
        ref="ueditor"
        v-model="form.content"
        :destroy="false"
        :config="editorConfig"
        @ready="ready"
      ></vue-ueditor-wrap>
    </el-form>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
export default {
  name: "sysmessage_form",
  components: {
    VueUeditorWrap
  },
  data() {
    return {
      form: {
        title: "",
        userID: "",
        content: ""
      },
      editorConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 300,
        // 初始容器宽度
        initialFrameWidth: "500px"
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: "http://admin.azz.lc/Public/plugin/ueditor/php/controller.php",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        // UEDITOR_HOME_URL: "/static/UEditor/",
        // 配合最新编译的资源文件，你可以实现添加自定义Request Headers,详情https://github.com/HaoChuan9421/ueditor/commits/dev-1.4.3.3
        // headers: {
        //   access_token: '37e7c9e3fda54cca94b8c88a4b5ddbf3'
        // },
      }
    };
  },
  methods: {
    ready(editorInstance) {
      console.log(`实例${editorInstance.key}已经初始化:`, editorInstance);
      console.log(111);
    }
  }
};
</script>

<style scoped>
</style>